<template>
    <div>
        <div v-for="(device_row,index) in devices_rows" :key="index">
            <v-row>
                <v-col cols="12"
                       sm="6">

                    <v-btn
                            class="mr-4 float-left"
                            fab
                            dark
                            small
                            color="pink"
                            @click="remove_row(index)" v-if="devices_rows.length > 1"
                    >
                        <v-icon>mdi-minus</v-icon>
                    </v-btn>


                    <v-combobox

                               @keydown.space="(event) => event.preventDefault()"
                               @change="change_row(device_row.device_id)"
                                :rules="[v => ( !(/^ /.test(v))) || 'no spaces allowed']"
                            v-model="device_row.device_id"
                            :disabled="!is_user_logged_in && !is_devices_page"
                            :items="device_list"
                             return-object="false"
                            item-value="id"
                            item-text="id"
                            dense
                             filled
                            label="Select or type-in device name"
                    ></v-combobox>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on"
                                   @click="openDeviceList(get_algorithm_id_by_index(index))"
                                   class="ma-2"
                                   outlined
                                   fab
                                   color="teal"
                                   :disabled="!devices_rows[index].device_id"
                            >
                                <v-icon>mdi-format-list-bulleted-square</v-icon>
                            </v-btn>
                        </template>
                        <span>Family-related devices</span>
                    </v-tooltip>
                </v-col>
                <v-col cols="12"
                       sm="6"
                >

                    <v-alert
                            border="right"
                            color="grey"
                            dark
                    >
                        <span> </span><span v-html="get_algorithm_desc_by_index(index)"></span>
                    </v-alert>
                    <v-alert
                            border="right"
                            color="grey"
                            dark
                    >
                        <span>  </span><span v-html="get_support_time_by_index(index)"></span>
                    </v-alert>
                </v-col>

            </v-row>
            <v-divider></v-divider>
            <v-row class="text-center">
                <v-col md="4"></v-col>
                <v-col md="4"></v-col>
                <v-col md="4"></v-col>
            </v-row>
        </div>

        <v-row v-if="notSupportedDeviceFound && !is_devices_page">
            <v-flex>
                <div class="text-center">
                    <v-btn
                            :disable="sendingEmail"
                            color="error"
                            class="text-center ma-2 white--text"
                            @click="emailPrecardToAdmin()"
                    >
                        <v-progress-circular
                                v-if="sendingEmail"
                                indeterminate
                                color="primary"
                        ></v-progress-circular>


                        <v-icon

                                color="white "
                        >
                            mdi-email
                        </v-icon>
                        Email this preorder to softlog for approval
                    </v-btn>
                </div>
            </v-flex>
        </v-row>

        <v-row>
            <v-col md="6" class=" pb-5">

                <v-btn
                        v-show="!hidden"
                        class="ma-2"
                        fab
                        dark
                        color="#000000"
                        :disabled="!devices_rows[devices_rows.length - 1].device_id"
                        @click="add_row()"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>


            </v-col>


            <v-col md="6" class="text-right">

                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                                v-on="on"
                                @click="openAllRowsDevicesList()"
                                class="ma-2"
                                outlined
                                fab
                                color="teal"
                        >
                            <v-icon>mdi-format-list-bulleted-square</v-icon>
                        </v-btn>
                    </template>
                    <span>Summary of family-related devices</span>
                </v-tooltip>
            </v-col>


        </v-row>

    </div>
</template>

<script>
    import Api from '../api.js';

    export default {
        name: "AddDevices",
        props: ['setText', 'setSnackbar', 'text', 'currentUserSelected', 'notSupportedDeviceFound', 'setNotSupportedDeviceFound', 'is_devices_page', 'openAllRowsDevicesList', 'add_row', 'openDeviceList', 'setDLL', 'setSecureProgramming', 'secure_programming', 'dll', 'device_list', 'devices_rows', 'change_row', 'remove_row', 'is_user_logged_in', 'algorithm_list', 'support_time'],
        data() {
            return {
                sendingEmail: false
            }
        },
        watch: {
            devices_rows: {
                handler: function (devicesRows) {
                    this.setNotSupportedDeviceFound(false);
                    devicesRows.forEach(device => {
                        //console.log(device);
                        // console.log(this.flatDevicesList);
                        //console.log(!this.flatDevicesList.includes(device.device_id.id));
                        if (device.device_id && !this.flatDevicesList.includes(device.device_id.id)) {
                            this.setNotSupportedDeviceFound(true);
                        }
                    })


                },
                deep: true
            }

        },
        computed: {
            flatDevicesList() {
                return this.device_list.map(device => device.id);
            }
        },

        methods: {
            forceUpper(e, o, prop) {
                 e.target.value = e.target.value.toUpperCase();
                this.$set(o, prop, e.target.value);
             },
            emailPrecardToAdmin() {

                this.sendingEmail = true
                this.setSnackbar(false);
                this.setText(`An e-mail with preorder details has been sent to Soflog,  We will contact you shortly by e-mail.`);
                Api.post('/order-app/email-precart-to-admin', {
                    "user": this.currentUserSelected,
                })

                    .then(() => {
                        this.sendingEmail = false;
                        this.setSnackbar(true);
                        // always executed
                    });

            },

            get_algorithm_text(index) {
                if (!this.devices_rows) {
                    return;
                }
                if (!this.devices_rows[index].device_id) {
                    return;
                }
                let algorithm = this.devices_rows[index].device_id.algorithm;
                // console.log(index);
                let algorithm_selected = this.algorithm_list[algorithm];
                //console.log(algorithm);

                return algorithm_selected.algorithm_description;
            }, get_algorithm_id_by_index(index) {


                if (this.devices_rows[index].device_id) {
                    return this.devices_rows[index].device_id['algorithm'];

                }
            }, get_algorithm_desc_by_index(index) {


                if (this.devices_rows[index].device_id) {

                    /// let cur_device = this.device_list.find(device => {
                    //    return device.id == this.devices_rows[index].device_id;
                    //});

                    let text = this.devices_rows[index].device_id.device_description;

                    if (typeof text === "undefined") {
                        return "";
                    } else {
                        return "<span class='returnSupported_text'>" + text + "</span>";
                    }
                } else {
                    return "Description";
                }
            },
            get_support_time_by_index(index) {


                if (this.devices_rows[index].device_id) {
                    let support_time_message = this.devices_rows[index].device_id['support_time'];
                    //  console.log('------------');
                    // console.log(support_time_message);
                //  let text = this.support_time.find((item) => {
                 //   return item.id == support_time_message;
             //     });
                  let text = this.support_time[support_time_message];

                    if (typeof text === "undefined") {
                        if(this.is_devices_page){
                            return '<span class=returnSupported_text_red>' + 'Device not found / supported.<br>Contact us for support<br>Try to remove suffix' + '</span>';
                        }else{
                            return '<span class=returnSupported_text_red>' + 'Device not found / supported<br>Try to remove suffix' + '</span>';
                        }
                    } else {
                        return '<span class=returnSupported_text>' + text.message + '</span>';
                    }
                } else {
                    return "Availability";
                }
            }
        }
    }
</script>

<style scoped>

</style>